"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _styles = require("../styles");

var _getResponsiveStyles = require("../styles/getResponsiveStyles");

var _emotionTheming = require("emotion-theming");

var _constants = require("./constants");

var _styled = require("./styled");

var _propTypes = require("./propTypes");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getGutterSize = function getGutterSize(theme, value) {
  return typeof value === 'number' && value !== 0 ? (0, _styles.pxToEm)(value) : theme["space_inline_" + value] || value;
};

var getIndexedValue = function getIndexedValue(property, index) {
  return property && Array.isArray(property) && index !== undefined ? property[index] : property;
};

var getMarginOrGutter = function getMarginOrGutter(_ref) {
  var gutterWidth = _ref.gutterWidth,
      index = _ref.index,
      margin = _ref.margin,
      marginEnd = _ref.marginEnd,
      marginHorizontal = _ref.marginHorizontal,
      marginStart = _ref.marginStart,
      start = _ref.start,
      theme = _ref.theme;
  return getIndexedValue(start ? marginStart : marginEnd, index) || getIndexedValue(marginHorizontal, index) || getIndexedValue(margin, index) || getGutterSize(theme, gutterWidth);
};

var getMarginProps = function getMarginProps(_ref2) {
  var direction = _ref2.direction,
      gutterWidth = _ref2.gutterWidth,
      theme = _ref2.theme,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["direction", "gutterWidth", "theme"]);

  if (Array.isArray(direction)) {
    return direction.reduce(function (acc, _, index) {
      var value = (0, _getResponsiveStyles.getPrevNonNull)(direction, index);

      if (value === _constants.DIRECTION.row || value === _constants.DIRECTION['row-reverse']) {
        pushMarginProps(_objectSpread({
          direction: value,
          index: index,
          gutterWidth: gutterWidth,
          props: acc,
          theme: theme
        }, restProps));
      } else {
        pushMarginProps(_objectSpread({
          index: index,
          gutterWidth: 0,
          props: acc,
          theme: theme
        }, restProps));
      }

      return acc;
    }, {
      marginStart: [],
      marginEnd: []
    });
  } else if (direction === _constants.DIRECTION.row || direction === _constants.DIRECTION['row-reverse']) {
    var _ref3;

    var flip = direction === _constants.DIRECTION['row-reverse'];
    var marginProperty = flip ? 'marginStart' : 'marginEnd';
    return _ref3 = {}, _ref3[marginProperty] = getMarginOrGutter(_objectSpread({}, restProps, {
      gutterWidth: gutterWidth,
      start: flip,
      theme: theme
    })), _ref3;
  }
};

var pushMarginProps = function pushMarginProps(_ref4) {
  var direction = _ref4.direction,
      index = _ref4.index,
      gutterWidth = _ref4.gutterWidth,
      props = _ref4.props,
      theme = _ref4.theme,
      restProps = _objectWithoutPropertiesLoose(_ref4, ["direction", "index", "gutterWidth", "props", "theme"]);

  var flip = direction === _constants.DIRECTION['row-reverse'];
  props.marginEnd.push(getMarginOrGutter(_objectSpread({}, restProps, {
    gutterWidth: flip ? 0 : gutterWidth,
    index: index,
    theme: theme
  })));
  props.marginStart.push(getMarginOrGutter(_objectSpread({}, restProps, {
    gutterWidth: flip ? gutterWidth : 0,
    index: index,
    start: true,
    theme: theme
  })));
};

var ThemedRoot = (0, _emotionTheming.withTheme)(function (_ref5) {
  var breakpoints = _ref5.breakpoints,
      children = _ref5.children,
      direction = _ref5.direction,
      gutterWidth = _ref5.gutterWidth,
      theme = _ref5.theme,
      restProps = _objectWithoutPropertiesLoose(_ref5, ["breakpoints", "children", "direction", "gutterWidth", "theme"]);

  var rootProps = _objectSpread({
    breakpoints: breakpoints,
    direction: direction,
    gutterWidth: gutterWidth
  }, restProps);

  var flexItems;
  flexItems = _react.Children.map(children, function (child, index) {
    if (child && child.props) {
      var _child$props = child.props,
          propBreakpoints = _child$props.breakpoints,
          restChildProps = _objectWithoutPropertiesLoose(_child$props, ["breakpoints"]);

      var props = {
        breakpoints: propBreakpoints || breakpoints
      };

      var flexItemsCount = _react.Children.count(children);

      if (gutterWidth && index < flexItemsCount - 1) {
        props = _objectSpread({}, props, getMarginProps(_objectSpread({
          direction: direction,
          gutterWidth: gutterWidth,
          theme: theme
        }, restChildProps)));
      }

      return (0, _react.cloneElement)(child, props);
    }

    return child;
  });
  return (0, _core.jsx)(_styled.FlexRoot, rootProps, flexItems);
});

var Flex = function Flex(props) {
  return (0, _core.jsx)(ThemedRoot, props);
};

Flex.displayName = 'Flex';
var defaultProps = {
  alignItems: _constants.ALIGN_ITEMS.stretch,
  direction: _constants.DIRECTION.row,
  gutterWidth: _constants.GUTTER_WIDTH.md,
  justifyContent: _constants.JUSTIFY_CONTENT.start
};
Flex.defaultProps = defaultProps;
Flex.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.flexPropTypes : {};
var _default = Flex;
exports.default = _default;